export function _MONTH_DIFF(d1: any, d2: any) {
	const day_1 = new Date(d1);
	const day_2 = new Date(d2);
	let months;
	months = (day_2.getFullYear() - day_1.getFullYear()) * 12;
	months -= day_1.getMonth();
	months += day_2.getMonth();
	return months <= 0 ? 0 : months;
}
